import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Typography,
} from "@suraasa/placebo-ui"
import api from "api"
import { LeadQualification } from "api/resources/lead/types"
import AsyncBuilder from "components/AsyncBuilder"
import { toast } from "react-toastify"

type Props = {
  open: boolean
  handleClose: () => void
  qualification: LeadQualification
  onDelete?: () => void
}

const QualificationDeleteDialog = ({
  open,
  handleClose,
  qualification,
  ...props
}: Props) => {
  const handleDelete = async () => {
    try {
      await api.lead.deleteQualification({
        params: {
          qualificationId: qualification.id,
        },
      })
      toast.info("Qualification deleted")
    } catch (error) {
      toast.error("Error deleting qualification")
    }

    if (props.onDelete) {
      props.onDelete()
    }
    handleClose()
  }
  return (
    <>
      <Dialog open={open} onOpenChange={handleClose}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              <Typography variant="strong">Delete Qualification</Typography>
            </DialogTitle>
          </DialogHeader>
          <DialogBody>
            <Typography variant="body">
              Are you sure you want to delete <b>{qualification.name}</b>{" "}
              qualification?
            </Typography>
          </DialogBody>
          <DialogFooter>
            <div>
              <Button
                variant="outlined"
                onClick={handleClose}
                className="mr-1.25 text-black"
                size="sm"
              >
                Cancel
              </Button>
              <AsyncBuilder
                handler={handleDelete}
                render={({ onClick, loading }) => (
                  <Button
                    onClick={onClick}
                    size="sm"
                    loading={loading}
                    color="critical"
                  >
                    Delete
                  </Button>
                )}
              />
            </div>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default QualificationDeleteDialog
